import { css, cx } from '@emotion/css'
import { theme } from '../styles/theme.js'

const styles = {
  base: css({
    backgroundColor: theme.colors.surface,
    borderRadius: theme.radii.lg,
    border: `1px solid ${theme.colors.border}`,
    padding: theme.spacing.lg,
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    '&:active': {
      transform: 'scale(0.995)',
    },
  }),
  elevated: css({
    backgroundColor: theme.colors.surfaceElevated,
  }),
}

const Card = ({ elevated = false, className, children, ...props }) => {
  const combined = cx(
    styles.base,
    elevated && styles.elevated,
    className
  )

  return (
    <div className={combined} {...props}>
      {children}
    </div>
  )
}

export { Card }
